import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";

import "bootstrap/dist/css/bootstrap.min.css";

const Update1008 = () => {
  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <h2 className="m-0">Оновлення 10.08</h2>
        <Badge bg="success">Реалізовано</Badge>
      </div>
      <p className="text-muted">
        Два основні покращення для щоденної роботи: зручніше опрацювання фактур KSeF, коли водій уже
        сам завантажив рахунок, і зрозуміліше керування прив&apos;язкою карток при імпорті даних
        за шаблоном.
      </p>

      <Alert variant="info">
        <b>Коротко:</b> якщо водій уже завантажив фактуру в кабінет — у KSeF її потрібно{" "}
        <b>підтвердити</b>, а не створювати нову і не відхиляти завантаження. При імпорті даних
        картки, прив&apos;язані до кількох водіїв, можна розібрати прямо зі сторінки імпорту
        (відв&apos;язати зайвих або переприв&apos;язати до одного).
      </Alert>

      <Accordion defaultActiveKey="0" alwaysOpen className="mb-4">
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. KSeF — пріоритет завантаження водія</Accordion.Header>
          <Accordion.Body>
            <p className="mb-2">
              Раніше з KSeF часто створювали нову фактуру на сайті, навіть якщо водій уже сам
              завантажив той самий рахунок у кабінет. У результаті з&apos;являлись дублікати, а
              завантаження водія лишалось «висячим» (очікує перевірки або відхилене).
            </p>
            <ul>
              <li>
                <b>Підтвердження завантаження водія.</b> Якщо система бачить у водія незакрите
                завантаження з тими ж сумами (брутто / VAT), під рядком KSeF з&apos;являється блок
                з кнопкою <b>«Підтвердити завантаження водія»</b>. Одним натисканням фактура
                прив&apos;язується до KSeF і одразу затверджується.
              </li>
              <li>
                <b>Не створюйте нову фактуру в такому випадку.</b> Кнопка «Створити фактуру»
                блокується, поки є завантаження саме цього водія. Спочатку підтвердіть його —
                так водій побачить, що перевірили саме його рахунок.
              </li>
              <li>
                <b>Відхилені завантаження теж можна підтвердити.</b> Якщо раніше завантаження
                помилково відхилили, через KSeF його можна підтвердити знову — без прохання до
                водія завантажувати файл ще раз.
              </li>
              <li>
                <b>Чужі завантаження з тією ж сумою.</b> У таксі часто трапляються однакові
                суми в різних водіїв. Система більше не блокує створення фактури через чужий
                upload: показує його лише як підказку («інший водій»), без кнопки підтвердження.
              </li>
              <li>
                <b>Якщо KSeF уже прив&apos;язано, а у водія лишилось старе завантаження</b> —
                під рядком з&apos;явиться жовте попередження. Таке завантаження потрібно
                відхилити або видалити в розділі фактур водіїв, щоб не плутало далі.
              </li>
              <li>
                <b>У кабінеті водія</b> на затвердженій через KSeF фактурі видно позначку KSeF і
                зрозумілий статус — що рахунок перевірено, а повернення буде в найближчому тижні.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Як працювати з KSeF після оновлення</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Відкрийте <b>«Рахунки» → «KSeF — фактури»</b>, оберіть місяць і покажіть список
                (з дампу або завантажте з KSeF).
              </li>
              <li>
                Дивіться колонку <b>«На сайті»</b>:
                <ul className="mt-2">
                  <li>
                    <Badge bg="success">Вже є</Badge> — фактура вже прив&apos;язана, нічого
                    створювати не потрібно.
                  </li>
                  <li>
                    <Badge bg="info">Завантаження водія</Badge> — водій уже завантажив рахунок:
                    підтвердіть його кнопкою під рядком.
                  </li>
                  <li>
                    <Badge bg="warning" text="dark">
                      Збіг сум
                    </Badge>{" "}
                    — є схожі фактури на сайті (можна переглянути список під рядком).
                  </li>
                  <li>
                    <Badge bg="light" text="dark">
                      Немає
                    </Badge>{" "}
                    — на сайті ще немає: оберіть водія і натисніть «Створити фактуру».
                  </li>
                </ul>
              </li>
              <li>
                <b>Правильний порядок:</b> спочатку підтвердити завантаження водія (якщо є) →
                лише якщо завантаження немає — створювати нову фактуру з KSeF.
              </li>
              <li>
                Не відхиляйте завантаження водія «просто так», якщо воно відповідає фактурі з
                KSeF — краще підтвердити.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Імпорт даних — картки з кількома водіями</Accordion.Header>
          <Accordion.Body>
            <p className="mb-2">
              При завантаженні файлу за шаблоном система зіставляє номер картки з профілями
              водіїв. Якщо одну й ту саму картку випадково прив&apos;язали до двох (або більше)
              водіїв, раніше такий рядок було складно розібрати. Тепер це можна зробити прямо
              на сторінці імпорту.
            </p>
            <ul>
              <li>
                <b>Статуси рядків:</b>
                <ul className="mt-1">
                  <li>
                    <Badge bg="success">Знайдено</Badge> — картка в одного водія, рядок можна
                    застосовувати.
                  </li>
                  <li>
                    <Badge bg="warning" text="dark">
                      Дубль
                    </Badge>{" "}
                    — картка в кількох водіїв; застосувати не можна, доки не розберете
                    прив&apos;язку.
                  </li>
                  <li>
                    <Badge bg="secondary">Не знайдено</Badge> — картки немає ні в кого; можна
                    прив&apos;язати до потрібного водія.
                  </li>
                </ul>
              </li>
              <li>
                <b>«Керувати» / «Вирішити дубль»</b> — відкриває вікно зі списком поточних
                прив&apos;язок. Можна відв&apos;язати зайвого водія або одразу переприв&apos;язати
                картку лише до одного обраного.
              </li>
              <li>
                <b>До застосування</b> потрапляють лише картки з рівно одним водієм. Це захищає
                від помилкового нарахування одразу двом людям.
              </li>
              <li>
                Після виправлення прив&apos;язки файл перечитується автоматично — статус рядка
                оновлюється, і його можна одразу вибрати для застосування.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>4. Як користуватись імпортом після оновлення</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Відкрийте <b>«Імпорт даних»</b>, завантажте файл за шаблоном.
              </li>
              <li>
                Перегляньте таблицю: жовті рядки (дубль) і сірі (не знайдено) не потраплять у
                застосування, доки їх не виправите.
              </li>
              <li>
                Для дубля натисніть <b>«Вирішити дубль»</b> → відв&apos;яжіть зайвих або
                переприв&apos;яжіть картку до одного водія.
              </li>
              <li>
                Для «не знайдено» натисніть <b>«Прив&apos;язати»</b> і оберіть водія.
              </li>
              <li>
                Коли потрібні рядки зелені (знайдено) і позначені галочками — оберіть тиждень,
                куди записати, відсоток, тип дії й опис → <b>«Застосувати»</b>.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>5. Інші зміни</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                У перегляді звіту водія прибрано інформаційну підказку про зарплату (окремий
                переказ раз на місяць) — текст більше не показується під полем зарплати.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>6. Який буде результат</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Менше дублікатів фактур: рахунок водія підтверджується, а не дублюється з KSeF.</li>
              <li>Водій бачить, що перевірили саме його завантаження (у т.ч. через KSeF).</li>
              <li>Менше плутанини з однаковими сумами у різних водіїв.</li>
              <li>Швидше розбираються «заплутані» картки при імпорті — без зайвих заходжень у профілі.</li>
              <li>Застосування імпорту безпечніше: тільки однозначні прив&apos;язки картка ↔ водій.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default Update1008;
